export default __webpack_public_path__ + "static/media/icon-seventh-rain.ae3ae14e.svg";